import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const NavigationStyles = styled.div<{ quotePage: boolean }>`
  .back-button-wrapper {
    display: flex;
    padding: 16px 0;
    margin: 0 16px;

    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      width: ${theme.grid.resolution.tablet.container}px;
      margin: 0 auto;
    }

    @media (min-width: ${theme.grid.resolution.desktop.width}px) {
      width: ${theme.grid.resolution.desktop.width}px;
    }
  }
  .step-wrapper {
    @media (min-width: ${theme.grid.resolution.desktop.width}px) {
      margin-top: -28px;
    }
  }

  ${({ quotePage }) =>
    quotePage &&
    `
      background-color: ${theme.primaryColours.aubergine.main};
      .button__previous {
        color: white;
        background: transparent;

        &:hover {
          background: none;
        }
      }
  `};
`
